import { isAppLocale } from "./locales";
import type { AppLocale } from "./locales";

export const getPathnameLocale = (pathname: string): AppLocale | null => {
  const [, maybeLocale] = pathname.split("/");

  return isAppLocale(maybeLocale) ? maybeLocale : null;
};

export const localizePathname = (pathname: string, locale: AppLocale) => {
  const normalizedPathname = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const currentLocale = getPathnameLocale(normalizedPathname);

  if (currentLocale !== null) {
    return normalizedPathname.replace(`/${currentLocale}`, `/${locale}`);
  }

  return `/${locale}${normalizedPathname}`;
};
